// @ts-nocheck
import { RSAA } from 'redux-api-middleware';

import {
  UPDATE_REQUESTED,
  UPDATE_SUCCESS,
  UPDATE_FAILURE,
  LIST_DATA_REQUESTED,
  LIST_DATA_SUCCESS,
  LIST_DATA_FAILURE,
} from './vipProgramTypes';
import constants from '../../../constants';

export const updateProgramAvailability = (
    record: { id: any, status: "OpenApplications" | "CloseApplications" },
) => {
  return async (dispatch, getState) => {
    const state = getState();

    const response = await dispatch({
      [RSAA]: {
        endpoint: `${constants.baseApiHost}/api/v2/CampaignAmbassadorProgram/${record.id}/activation`,
        method: 'PUT',
        headers: {
          ApiKey: constants.apikey,
          Authorization: `bearer ${state.session.key}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ isActive: record.status === "OpenApplications" }),
        types: [
          {
            type: UPDATE_REQUESTED,
            payload: async (action, state, res) => {
              return {
                key: 'editProgramRecord'
              };
            }
          },
          {
            type: UPDATE_SUCCESS,
            payload: async (action, state, res) => {
              const json = await res.json();
              return {
                ...json,
                key: 'editProgramRecord'
              };
            }
          },
          {
            type: UPDATE_FAILURE,
            payload: async (action, state, res) => {
              const json = await res.json();
              return {
                ...json,
                key: 'editProgramRecord',
                status: res.status
              };
            }
          }
        ]
      }
    });

    if (response.type === 'vipProgram/UPDATE_SUCCESS') {
      const request = state.program.eventPrograms.request;
      dispatch({
        [RSAA]: {
          endpoint: `${constants.baseApiHost}/api/v2/CampaignAmbassadorProgram/search`,
          method: 'POST',
          headers: {
            ApiKey: constants.apikey,
            Authorization: `bearer ${state.session.key}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(request),
          types: [
            {
              type: LIST_DATA_REQUESTED,
              payload: (action, state) => ({
                id: undefined,
                key: 'eventPrograms',
                request,
                invalidate: true,
                fetchRequired: true,
              })
            },
            {
              type: LIST_DATA_SUCCESS,
              payload: async (action, state, res) => {
                const payload = await res.json();
                return Object.assign({}, payload, { id: undefined, key: 'eventPrograms' });
              }
            },
            {
              type: LIST_DATA_FAILURE,
              payload: async (action, state, res) => {
                const json = await res.json();
                return {
                  key: 'eventPrograms',
                  status: res.status,
                  ...json
                };
              }
            }
          ]
        }
      });
    }
  };
}
